







import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'Chips',
})
export default class Chips extends Vue {
  @Prop({type: String, default: ''}) public readonly name!: string;
  @Prop({type: Number}) public readonly value!: string;
  @Prop({type: Boolean, default: false}) public readonly isActive!: boolean;
}
